// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "机器学习",
      "tec": "刘娜",
      "week": "6-9周",
      "add": "教学楼B座421能动"
    },
    0,
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "网络安全应急响应",
      "tec": "白雪峰",
      "week": "1-4周",
      "add": "教学楼C座113教务"
    },
    {
      "sub": "软件安全分析与应用",
      "tec": "赵丹",
      "week": "1-4周",
      "add": "实训楼F座302信息"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "机器学习",
      "tec": "刘娜",
      "week": "6-9周",
      "add": "教学楼B座119自控"
    },
    {
      "sub": "区块链技术",
      "tec": "郭朋伟",
      "week": "1-11周",
      "add": "教学楼B座121自控"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "网络安全应急响应",
      "tec": "白雪峰",
      "week": "1-4单周",
      "add": "教学楼C座113教务"
    },
    {
      "sub": "软件安全分析与应用",
      "tec": "赵丹",
      "week": "1-4单周",
      "add": "教学楼C座303教务"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "区块链技术",
      "tec": "郭朋伟",
      "week": "1-11单周",
      "add": "教学楼B座121自控"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
